import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {
  ACCOMMODATION_TYPE_FLOOR,
  ACCOMMODATION_TYPE_PERSONALISATION,
  ACCOMMODATION_TYPE_ROOMS,
  ACCOMMODATION_TYPE_UPGRADES,
  ACCOMMODATION_TYPE_CATEGORY,
  ACCOMMODATION_TYPE_ROOM_TYPE,
  ACCOMMODATION_TYPE_PACKAGES,
  PACKAGE_CREATE,
  PACKAGE_EDIT,
  PACKAGE_VIEW,
  CATEGORY_CREATE,
  CATEGORY_EDIT,
  CATEGORY_VIEW,
  FLOOR_CREATE,
  FLOOR_EDIT,
  FLOOR_VIEW,
  ROOM_TYPE_CREATE,
  ROOM_TYPE_EDIT,
  ROOM_TYPE_VIEW,
  ROOM_CREATE,
  ROOM_EDIT,
  ROOM_VIEW,
  UPGRADE_CREATE,
  UPGRADE_VIEW,
  UPGRADE_EDIT,
  PERSONALISATION_CREATE,
  PERSONALISATION_EDIT,
  PERSONALISATION_VIEW,
  ACCOMMODATION_TYPE_RATE_FILTERS,
  RATE_FILTERS_EDIT,
  RATE_FILTERS_CREATE,
  RATE_FILTERS_VIEW,
  ACCOMMODATION_TYPE_PREFERENCE,
  PREFERENCE_CREATE,
  PREFERENCE_EDIT,
  PREFERENCE_VIEW,
} from '../../../constants/AccomodationConst';
import { Drawer } from '@material-ui/core';
import CategoryList from './category/category-list/Category-List';
import CategoryView from './category/category-view/Category-View';
import CategoryCreate from './category/category-create/Category-Create';
import {
  allPropertyConfigsSelector,
  fetchAllAccommodations,
  fetchAllPropertyConfigData,
  selectedHotelSelector,
} from '../../property/propertySlice';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FloorList from './floor/floor-list/Floor-List';
import FloorCreate from './floor/floor-create/Floor-Create';
import FloorView from './floor/floor-view/Floor-View';
import RoomTypeList from './room-type/room-type-list/RoomType-List';
import RoomTypeCreate from './room-type/room-type-create/RoomType-Create';
import RoomTypeView from './room-type/room-type-view/Room-Type-View';
import RoomList from './room/room-list/Room-List';
import RoomCreate from './room/room-create/Room-Create';
import RoomView from './room/room-view/Room-View';
import './Accommodations.scss';
import PersonalisationList from './personalisation/personalisation-list/Personalisation-List';
import UpgradeList from './upgrades/upgrade-list/Upgrade-List';
import UpgradeCreate from './upgrades/upgrade-create/Upgrade-Create';
import UpgradeView from './upgrades/upgrade-view/Upgrade-View';
import PackagesList from './packages/packages-list/Packages-List';
import PackageCreate from './packages/packages-create/Package-Create';
import PersonalisationCreate from './personalisation/personalisation-create/Personalisation-Create';
import PackageView from './packages/package-view/Package-View';
import PersonalisationView from './personalisation/personalisation-view/Personalisation-View';
import { validateUserSession } from '../../../utils/authUtils';
import RateFiltersList from './rate-filters/rate-filters-list/RateFiltersList';
import RateFiltersCreate from './rate-filters/rate-filters-create/RateFiltersCreate';
import RateFiltersView from './rate-filters/rate-filters-view/RateFiltersView';
import PreferenceList from './preference/preference-list/PreferenceList';
import PreferenceCreate from './preference/preference-create/PreferenceCreate';
import PreferenceView from './preference/preference-view/PreferenceView';
import SyncButton from '../../../shared/sync-button/Sync-Button';
import { generatedElapsedTime } from '../../../utils/dashboardUtils';
import moment from 'moment';
import { syncPreferences } from '../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Accomodations = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(ACCOMMODATION_TYPE_CATEGORY); // "ROOM_TYPES" | "ROOMS" | "FLOOR" | "UPGRADES" | "PERSONALISATION"
  const [state, setState] = useState({ type: CATEGORY_CREATE, status: false });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const selectedHotel = useSelector(selectedHotelSelector);
  const [viewState, setViewState] = useState({
    type: CATEGORY_VIEW,
    status: false,
    obj: null,
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const propertyConfigs = useSelector(allPropertyConfigsSelector);
  const [lastSyncPref, setLastSyncPref] = useState(0);

  useEffect(() => {
    if (
      activeTab === ACCOMMODATION_TYPE_CATEGORY ||
      activeTab === ACCOMMODATION_TYPE_FLOOR ||
      activeTab === ACCOMMODATION_TYPE_ROOM_TYPE ||
      activeTab === ACCOMMODATION_TYPE_ROOMS ||
      activeTab === ACCOMMODATION_TYPE_PACKAGES ||
      activeTab === ACCOMMODATION_TYPE_UPGRADES ||
      activeTab === ACCOMMODATION_TYPE_PERSONALISATION
    ) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(ACCOMMODATION_TYPE_CATEGORY);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchAllPropertyConfigData(selectedHotel));
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (propertyConfigs?.preference?.lastSyncedAt) {
      const diff = generatedElapsedTime(
        moment(),
        moment.unix(propertyConfigs.preference.lastSyncedAt),
        true,
      );
      setLastSyncPref(diff);
    }
  }, [propertyConfigs.preference]);

  const onClickSyncPref = async (e) => {
    e.preventDefault();
    try {
      const { data } = await syncPreferences(selectedHotel);
      notificationManager(
        data.syncPreference.status ? 'success' : 'danger',
        data.syncPreference.message,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
    } catch (err) {
      console.error(err);
    }
  };

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case CATEGORY_CREATE:
        return (
          <CategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></CategoryCreate>
        );
      case CATEGORY_EDIT:
        return (
          <CategoryCreate
            toggleDrawer={onDrawerToggle}
            category={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></CategoryCreate>
        );
      case ROOM_TYPE_CREATE:
        return (
          <RoomTypeCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></RoomTypeCreate>
        );
      case ROOM_TYPE_EDIT:
        return (
          <RoomTypeCreate
            toggleDrawer={onDrawerToggle}
            roomType={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></RoomTypeCreate>
        );
      case FLOOR_CREATE:
        return (
          <FloorCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></FloorCreate>
        );
      case FLOOR_EDIT:
        return (
          <FloorCreate
            toggleDrawer={onDrawerToggle}
            floor={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></FloorCreate>
        );
      case ROOM_CREATE:
        return (
          <RoomCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></RoomCreate>
        );
      case ROOM_EDIT:
        return (
          <RoomCreate
            toggleDrawer={onDrawerToggle}
            room={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></RoomCreate>
        );
      case UPGRADE_CREATE:
        return (
          <UpgradeCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></UpgradeCreate>
        );
      case UPGRADE_EDIT:
        return (
          <UpgradeCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            upgrade={state.obj}
            showLoader={showLoader}
          ></UpgradeCreate>
        );
      case PACKAGE_CREATE:
        return (
          <PackageCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></PackageCreate>
        );
      case PACKAGE_EDIT:
        return (
          <PackageCreate
            toggleDrawer={onDrawerToggle}
            packageObj={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></PackageCreate>
        );
      case PERSONALISATION_CREATE:
        return (
          <PersonalisationCreate
            toggleDrawer={onDrawerToggle}
            room={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></PersonalisationCreate>
        );
      case PERSONALISATION_EDIT:
        return (
          <PersonalisationCreate
            toggleDrawer={onDrawerToggle}
            room={state.obj}
            hotelId={selectedHotel}
            personalisation={state.obj}
            showLoader={showLoader}
          ></PersonalisationCreate>
        );
      case RATE_FILTERS_CREATE:
        return (
          <RateFiltersCreate
            toggleDrawer={onDrawerToggle}
            room={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></RateFiltersCreate>
        );
      case RATE_FILTERS_EDIT:
        return (
          <RateFiltersCreate
            toggleDrawer={onDrawerToggle}
            room={state.obj}
            hotelId={selectedHotel}
            rateFilter={state.obj}
            showLoader={showLoader}
          ></RateFiltersCreate>
        );
      case PREFERENCE_CREATE:
        return (
          <PreferenceCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case PREFERENCE_EDIT:
        return (
          <PreferenceCreate
            toggleDrawer={onDrawerToggle}
            obj={state.obj}
            hotelId={selectedHotel}
            editing={true}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case CATEGORY_VIEW:
        return (
          <CategoryView
            category={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            selectedHotel={selectedHotel}
            permissions={permissions}
          ></CategoryView>
        );
      case FLOOR_VIEW:
        return (
          <FloorView
            floor={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></FloorView>
        );
      case ROOM_TYPE_VIEW:
        return (
          <RoomTypeView
            roomType={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></RoomTypeView>
        );
      case PACKAGE_VIEW:
        return (
          <PackageView
            packObj={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></PackageView>
        );
      case ROOM_VIEW:
        return (
          <RoomView
            room={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></RoomView>
        );
      case UPGRADE_VIEW:
        return (
          <UpgradeView
            upgrade={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></UpgradeView>
        );
      case PERSONALISATION_VIEW:
        return (
          <PersonalisationView
            personalisation={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            permissions={permissions}
            hotelId={selectedHotel}
          ></PersonalisationView>
        );
      case RATE_FILTERS_VIEW:
        return (
          <RateFiltersView
            rateFilter={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            permissions={permissions}
            hotelId={selectedHotel}
          ></RateFiltersView>
        );
      case PREFERENCE_VIEW:
        return (
          <PreferenceView
            onViewToggle={onViewToggle}
            onDrawerToggle={onDrawerToggle}
            permissions={permissions}
            object={inpState.obj}
          />
        );
      default:
        break;
    }
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Accommodations</span>
            </div>
            {/* Sync button for Preference tab */}
            {activeTab === ACCOMMODATION_TYPE_PREFERENCE && (
              <div className='col-md-6 d-flex justify-content-end'>
                <SyncButton lastSync={lastSyncPref} onClickSync={onClickSyncPref} />
              </div>
            )}
          </div>
          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_CATEGORY ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_CATEGORY
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_CATEGORY)}
              >
                Category
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_ROOM_TYPE ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_ROOM_TYPE
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_ROOM_TYPE)}
              >
                Room Type
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_PACKAGES ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_PACKAGES
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_PACKAGES)}
              >
                Packages
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_ROOMS ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_ROOMS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_ROOMS)}
              >
                Room No
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_FLOOR ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_FLOOR
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_FLOOR)}
              >
                Floor
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_UPGRADES ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_UPGRADES
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_UPGRADES)}
              >
                Upgrades
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_PERSONALISATION ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_PERSONALISATION
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_PERSONALISATION)}
              >
                Personalisation
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_RATE_FILTERS ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_RATE_FILTERS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_RATE_FILTERS)}
              >
                Rate Filters
              </Button>
              <Button
                size='large'
                variant={activeTab === ACCOMMODATION_TYPE_PREFERENCE ? 'outlined' : 'text'}
                className={
                  activeTab === ACCOMMODATION_TYPE_PREFERENCE
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(ACCOMMODATION_TYPE_PREFERENCE)}
              >
                Preference
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === ACCOMMODATION_TYPE_CATEGORY && (
                <CategoryList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_FLOOR && (
                <FloorList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_ROOM_TYPE && (
                <RoomTypeList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_ROOMS && (
                <RoomList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_PACKAGES && (
                <PackagesList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_UPGRADES && (
                <UpgradeList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_PERSONALISATION && (
                <PersonalisationList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_RATE_FILTERS && (
                <RateFiltersList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === ACCOMMODATION_TYPE_PREFERENCE && (
                <PreferenceList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Accomodations;
